// extracted by mini-css-extract-plugin
export default {"component":"AuthLayout_component__vfSWA","centerItems":"AuthLayout_centerItems__W39pG","contentDiv":"AuthLayout_contentDiv__l+R8S"};